<template>
  <div class="logo">
    <router-link :to="{name:'dashboard'}">
      <!-- <img src="~@/assets/logo2.png" alt="logo"> -->
      <h1 v-if="showTitle">{{ title }}</h1>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Logo',
  props: {
    title: {
      type: String,
      default: '会员平台',
      required: false
    },
    showTitle: {
      type: Boolean,
      default: true,
      required: false
    }
  }
}
</script>
